const general = {
    placeholder: 'متن نمونه',
    submit: 'ارسال',
    skip: 'رد کردن',
    next: 'بعدی',
    back: 'قبلی',
    retry: 'تلاش مجدد',
    done: 'انجام شد',
    search: 'جستجو',
    search_placeholder: 'جستجو',
    clear_result: 'پاک کردن نتایج',
    today: 'امروز',
    clear: 'پاک کردن',
    save: 'ذخیره',
    save_changes: 'ذخیره تغییرات',
    saved: 'ذخیره شد',
    discard: 'رد کردن',
    download: 'دانلود',
    loading: 'در حال بارگذاری...',
    redirecting: 'در حال هدایت...',
    add: 'افزودن',
    added: 'افزوده شد',
    cancel: 'لغو',
    confirm: 'تأیید',
    check_out: 'مشاهده',
    create: 'ایجاد',
    set_up: 'راه‌اندازی',
    customize: 'سفارشی‌سازی',
    enable: 'فعال‌سازی',
    disable: 'غیرفعال‌سازی',
    reminder: 'یادآوری',
    edit: 'ویرایش',
    delete: 'حذف',
    deleted: 'حذف شد',
    activate: 'فعال کردن',
    deactivate: 'غیرفعال کردن',
    more_options: 'گزینه‌های بیشتر',
    close: 'بستن',
    copy: 'کپی',
    copying: 'در حال کپی',
    copied: 'کپی شد',
    required: 'الزامی',
    add_another: 'افزودن مورد دیگر',
    create_another: 'ایجاد مورد دیگر',
    deletion_confirmation: 'آیا مطمئن هستید که می‌خواهید این {{title}} را حذف کنید؟',
    settings_nav: 'تنظیمات',
    unsaved_changes_warning: 'تغییراتی انجام داده‌اید. آیا مطمئن هستید که می‌خواهید این صفحه را ترک کنید؟',
    leave_page: 'ترک صفحه',
    stay_on_page: 'ماندن در صفحه',
    type_to_search: 'برای جستجو تایپ کنید',
    got_it: 'متوجه شدم',
    continue: 'ادامه',
    page_info: '{{min, number}}-{{max, number}} از {{total, number}}',
    learn_more: 'بیشتر بدانید',
    tab_error: '{{count, number}} خطا',
    tab_error_other: '{{count, number}} خطا',
    skip_for_now: 'فعلاً رد کردن',
    remove: 'حذف',
    visit: 'بازدید',
    join: 'پیوستن',
    try_now: 'همین الان امتحان کنید',
    multiple_form_field: '(چندگانه)',
    demo: 'نسخه نمایشی',
    unnamed: 'بی‌نام',
    view: 'مشاهده',
    open: 'باز کردن',
    hide: 'پنهان کردن',
    unknown_error: 'خطای ناشناخته، لطفاً بعداً دوباره تلاش کنید.',
    select: 'انتخاب',
    contact_us_action: 'تماس با ما',
    description: 'توضیحات',
    name: 'نام',
    add_field: 'افزودن {{field}}',
    create_field: 'ایجاد {{field}}',
    edit_field: 'ویرایش {{field}}',
    delete_field: 'حذف {{field}}',
    coming_soon: 'به زودی',
    or: 'یا',
    reset: 'بازنشانی',
    generate: 'تولید',
    manage: 'مدیریت',
    live_preview: 'پیش‌نمایش زنده',
};
export default Object.freeze(general);
